<template>
    <div>
        <v-toolbar dense absolute light
                   style="width:125px"
                   color="white">
            <v-btn icon @click="game.pause()">
                <v-icon>pause</v-icon>
            </v-btn>
            <v-btn icon @click="game.unpause()">
                <v-icon>play_arrow</v-icon>
            </v-btn>
        </v-toolbar>
        <canvas id="world"></canvas>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Game from './Fliebert/Core/Game'

export default {
    data () {
        return {
            game: null,
        }
    },
    computed: {
        ...mapGetters([ 'accentColor' ]),
    },
    mounted () {
        this.game = new Game('#world').start()
    },
}

</script>

<style scoped lang="scss">
    #world {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 96px);
        background-color: black
    }
</style>
